const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://mexitaxis.dvgeo.app' : 'http://192.168.100.106:3028',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://mexitaxis.dvgeo.app' : 'http://192.168.100.106:3028',
    api: 'api/',
    apiSocket: 'mexitaxis::1.2',
    nameDir: 'mexitaxis',
    package: 'mx.mexitaxis.web',
    version: '1.0.0',
    googleAPIKey: 'AIzaSyBggc_-FBiM-8t2oU107VXM9SkbeTJCaiQ',
    appName: 'MexiTaxis',
    provider: '',
    colorPrimary: '#dc510c',
    colorDark: '#2f6646',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'mx.mexitaxis.passenger',
    playStoreDriverId: 'mx.mexitaxis.driver',
    appStorePassengerId: '6761637934',
    appStoreDriverId: '6761638068',
};
export default config;
